import { useFormik } from "formik";
import { useSimpleRequest } from "hooks";
import { when } from "util/support";
import { getDirtyFields } from "util/forms";
import { postMerchantVisibleMethods, deleteMerchantVisibleMethods } from "features/paymentMethods/api";
import useVisiblePaymentMethods from "./useVisiblePaymentMethods";

const usePaymentMethodsController = ({
    getPaymentMethods,
    fetchVisiblePaymentMethods
}: ReturnType<typeof useVisiblePaymentMethods>) => {
    const request = useSimpleRequest({
        shouldNotifyOnSuccess: true
    });

    const form = useFormik({
        enableReinitialize: true,
        initialValues: getPaymentMethods()
            .reduce((acc, { tag, coreId, isVisible }) => ({
                ...acc,
                [tag]: [coreId, Boolean(isVisible)]
            }), {}),
        onSubmit: async (values, { resetForm }) => {
            await Promise.allSettled(
                Object.entries(getDirtyFields({
                    values,
                    touched: form.touched,
                    initialValues: form.initialValues
                })).map(([
                    tag,
                    values
                ]) => {
                    const [coreId, isVisible] = values as [string, boolean];

                    return when(
                        isVisible,
                        () => request(() => postMerchantVisibleMethods({
                            tag
                        })),
                        () => request(() => deleteMerchantVisibleMethods({
                            coreId
                        }))
                    )
                })
            );

            await fetchVisiblePaymentMethods();

            resetForm();
        },
    });

    return form;
};

export default usePaymentMethodsController;
